module.exports = __webpack_public_path__ + "img/item_part_battery.27f3a123.png";